/**
 * Animation Format Constants
 *
 * Shared configuration and options for Gutenberg editor controls and
 * frontend Interactivity API animations.
 */

// Format Registration & Identification
export const FORMAT_NAME = 'amp/animate-format';
export const FORMAT_TITLE = 'Animate Text';
export const FORMAT_TAG = 'span';
export const FORMAT_CLASS = 'amp-animate';

// WordPress Interactivity API Store Namespace (matches AnimateFormat::NAMESPACE in PHP)
export const STORE_NAMESPACE = 'mbm/animate';

// HTML Attributes / Dataset keys (matches AnimateFormat::ANIMATION_ATTR in PHP)
export const ATTR_ANIMATION = 'data-animation';
export const ATTR_SPEED = 'data-speed';
export const ATTR_WORDS = 'data-words';

// Animation Style Options
export const DEFAULT_ANIMATION = 'fade-in';

export const ANIMATION_OPTIONS = [
  { label: 'Select animation...', value: '' },
  { label: 'Bounce', value: 'bounce' },
  { label: 'Decode', value: 'decode' },
  { label: 'Fade In', value: 'fade-in' },
  { label: 'Rotate', value: 'rotate' },
  { label: 'Slide Up', value: 'slide-up' },
  { label: 'Typewriter', value: 'typewriter' },
];

// Unified Speed Options: Serves both UI SelectControl and runtime animation engine
export const DEFAULT_SPEED = 'normal';

export const SPEED_OPTIONS = [
  {
    label: 'Normal',
    value: 'normal',
    multiplier: 1,
    interval: 2000,
  },
  {
    label: 'Slow',
    value: 'slow',
    multiplier: 1.5,
    interval: 3000,
  },
  {
    label: 'Fast',
    value: 'fast',
    multiplier: 0.5,
    interval: 1200,
  },
];

// Fast O(1) runtime lookup map derived directly from SPEED_OPTIONS
export const SPEED_MAP = Object.fromEntries(
  SPEED_OPTIONS.map((opt) => [opt.value, opt])
);

// Typewriter Cursor Classes
const CURSOR_BASE = 'amp-typewriter-cursor';

export const CURSOR_CLASSES = {
  base: CURSOR_BASE,
  hidden: `${CURSOR_BASE}--hidden`,
};

// Intersection Observer Configuration
export const OBSERVER_CONFIG = {
  threshold: 0.1,
  rootMargin: '0px 0px -50px 0px',
};

// Animation Timing Constants
export const INITIAL_CYCLE_DELAY = 500;

// Decode Effect Character Scramble Set
export const DECODE_CHARACTERS =
  'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789!@#$%&*';
